/**
 * Die eine Bewertungsskala 1-10 (Leitlinie 6, D-04): 10 = gut, 1 = schlecht.
 * Die Farben stehen zentral in tailwind.css (`--color-skala-1` bis `-10`).
 */
export function skalaStufe(wert: number): number {
  return Math.min(10, Math.max(1, Math.round(wert)));
}

export function skalaFarbe(wert: number): string {
  return `var(--color-skala-${skalaStufe(wert)})`;
}
